import { c as _c } from "react/compiler-runtime";
const Pending = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="m8 1.71 6.268 11.491H1.732L8 1.711ZM5.1 11.201h5.798l-2.9-5.314-2.898 5.314Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Pending;